module.exports = __webpack_public_path__ + "static/media/semi_detached_orange.0cf3c1e9.svg";